if (!customElements.get('md-story-gallery')) {
 customElements.define('md-story-gallery', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();
   this.controller = new AbortController();
   const { signal } = this.controller;
   this.track = this.querySelector('[data-track]');
   this.controls = this.querySelector('[data-controls]');
   if (!this.track) return;
   this.slides = Array.from(this.track.children);
   this.index = -1;
   this.update = () => {
    const width = this.track.clientWidth;
    const nextIndex = width ? Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width))) : 0;
    if (nextIndex === this.index) return;
    this.index = nextIndex;
    this.dataset.first = String(this.index === 0);
    this.slides.forEach((slide, i) => { if (i !== this.index) slide.querySelectorAll('video').forEach(v => v.pause()); });
    if (this.controls) {
     this.querySelector('[data-counter]').textContent = `${this.index + 1} / ${this.slides.length}`;
     this.querySelector('[data-prev]').disabled = this.index === 0;
     this.querySelector('[data-next]').disabled = this.index === this.slides.length - 1;
    }
   };
   const move = delta => {
    const target = Math.max(0, Math.min(this.slides.length - 1, this.index + delta));
    this.track.scrollTo({left: target * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
   };
   this.scheduleUpdate = () => {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
   };
   this.track.addEventListener('scroll', this.scheduleUpdate, {passive:true, signal});
   this.track.addEventListener('keydown', e => {
    if (e.target !== this.track || !['ArrowLeft','ArrowRight'].includes(e.key)) return;
    e.preventDefault(); move(e.key === 'ArrowLeft' ? -1 : 1);
   }, {signal});
   if (this.controls) {
    this.controls.hidden = false;
    this.querySelector('[data-prev]').addEventListener('click', () => move(-1), {signal});
    this.querySelector('[data-next]').addEventListener('click', () => move(1), {signal});
   }
   this.observer = new ResizeObserver(this.scheduleUpdate);
   this.observer.observe(this.track);
   this.update();
  }
  disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.frame = null; }
 });
}
